import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import lightBulb from './images/light-bulb.svg';
import AbroadPhonesInstructions from '../AbroadPhonesInstructionsBlock/AbroadPhonesInstructions';

const AbroadPhonesInfoBlock = () => {
  return (
    <div className='abroad-phones-info-container'>
      <div className='container-padding'>
        <div className='header-container-abroad-phones'><Image src={lightBulb} alt="light bulb" />
          <span>חשוב לדעת לפני הטיסה</span>
        </div>
        <p className='description-txt'>יש להפעיל נדידת נתונים במכשיר כדי שהחבילה תעבוד לאחר הנחיתה</p>
        <div className="phones-info-container"><AbroadPhonesInstructions /></div>
      </div>
    </div>
  );
};

export default AbroadPhonesInfoBlock;
